import { List } from 'immutable';
import { map, prop } from 'ramda';
import { VideoRepresentation } from 'src/dashboard/types';

export const getShortcodesFromVideosList = (
  videos: List<VideoRepresentation>
) => map(prop<string>('shortcode'), videos.toArray());
